import React, { useCallback } from 'react';
import { Select, useSelect } from '@vtblife/uikit';

import { DealType } from '@search/filter-enums/enums';
import { DealTypeFilter } from '../../../../models/Filter';

interface IMobileDealTypeFilterViewProps {
    filter: DealTypeFilter;
    enabledDealTypes?: DealType[];
    handleChange: (filter: DealTypeFilter) => void;
    native?: boolean;
}

function getOptions(enabledSegments: DealType[]) {
    return selectOptions.map(item => {
        if (! enabledSegments.includes(item.value)) {
            item.disabled = true;
        } else {
            item.disabled = false;
        }

        return item;
    });
}

const selectOptions = [ {
    value: DealType.SELL,
    label: 'Купить',
    disabled: false
}, {
    value: DealType.RENT,
    label: 'Снять',
    disabled: false
} ];

export const MobileDealTypeFilterView: React.FC<IMobileDealTypeFilterViewProps> = ({
    filter,
    enabledDealTypes = [ DealType.SELL, DealType.RENT ],
    handleChange,
    native
}) => {
    const value = filter.dealType;

    const onChange = useCallback((next: DealType[] | DealType) => {
        const newValue = Number(Array.isArray(next) ? next[0] : next);

        handleChange(new DealTypeFilter(newValue));
    }, [ handleChange ]);

    const options = getOptions(enabledDealTypes);

    const prepared = options.map(option => ({ value: option.value, text: option.label }));

    const { handleChange: handleSelectChange, is, selectedText } = useSelect(
        onChange,
        { selected: value, texts: prepared }
    );

    return (
        <Select native={native} mode='single' onChange={handleSelectChange}>
            <Select.Button size='s' dataTest='dealType'>{selectedText}</Select.Button>
            <Select.Content>
                {options.map(option => {
                    return (
                        <Select.Option
                            dataTest={`dealType-${option.value}`}
                            disabled={option.disabled}
                            key={option.value}
                            value={option.value}
                            selected={is(option.value)}
                        >
                            {option.label}
                        </Select.Option>
                    );
                })}
            </Select.Content>
        </Select>
    );
};
